module.exports = __webpack_public_path__ + "media/images/strategic-partners/spruce-119a73824b9bf62d86af63842b7ad077.jpeg";